/**
 * Hotel public contact details. Single source of truth for the reception
 * phone + office email rendered on the footer, legal pages, design contact
 * page, and the checkout thank-you / bank-transfer pages.
 *
 * `*_DISPLAY` is what we render to the user (with spaces, country prefix,
 * etc.); `*_TEL` is the digits-only form intended for `href="tel:..."`.
 * Update these in one place — every location imports from here.
 */

export const HOTEL_PHONE_DISPLAY = '+40 725 942 787';
export const HOTEL_PHONE_TEL = '+40725942787';

export const HOTEL_EMAIL = 'office@danielcastle.ro';

/**
 * Inquiry-desk contacts surfaced in the corporate / events auto-reply emails.
 * Centralised here (not inlined in the message catalogues) so that when the
 * responsible colleague's number changes, it changes in exactly one place and
 * every localised email picks it up. The corporate contact name is kept as a
 * per-locale record because the Hungarian copy uses the full Hungarian name
 * form; the phone is shared across locales.
 */
export const CORPORATE_CONTACT_NAME: Record<'en' | 'ro' | 'hu', string> = {
  en: 'Mark',
  ro: 'Mark',
  hu: 'Márk Előd',
};
export const CORPORATE_CONTACT_PHONE = '+40 741 129 484';

export const EVENTS_CONTACT_PHONE = '+40 721 934 446';
